import { Konva } from './_FullInternals.js';
export default Konva;
